import _get from 'lodash/get';
import { Values } from '@lib/interfaces/form';
import { SsoConfigTab, SsoIntegrationFieldNames } from './constants';

export default function isTab(tab: SsoConfigTab) {
  return (values: Values) =>
    _get(values, SsoIntegrationFieldNames.ConfigTab) === tab;
}
